"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserIconDisplayName = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const DisplayName_1 = require("./DisplayName");
const Styled = styled_components_1.default.a `
	.eg-header-icon-user {
		position: relative;
		&::after {
			content: "";
			display: block;
			position: absolute;
			right: 2px;
			bottom: -1px;
			width: 8px;
			height: 8px;
			border-radius: 50%;
			background-color: #52971c;
		}
	}
`;
const UserIconDisplayName = ({ displayName }) => {
    return (react_1.default.createElement(Styled, { role: "menuitem", onMouseDown: epic_games_nav_shared_1.stopFocusOnClick, title: displayName },
        react_1.default.createElement("i", { className: "eg-header-icon-user" }),
        react_1.default.createElement(DisplayName_1.DisplayName, { displayName: displayName })));
};
exports.UserIconDisplayName = UserIconDisplayName;
//# sourceMappingURL=UserIconDisplayName.js.map